export const SUBSIDY_WITHOUT_INCOME_URL = {
  GET_ALL_WITHOUT_INCOME_CONFIGURATION: '/without-income-configurations',
  CREATE_WITHOUT_INCOME_CONFIGURATION: '/without-income-configurations',
  UPDATE_WITHOUT_INCOME_CONFIGURATION: '/without-income-configurations',
  GET_ALL_APPLICATION_TYPE_REQUEST: '/application/request'
};
